var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"InputHora"}},[_c('input',{ref:"horaTarefa",staticClass:"timepicker",attrs:{"id":"horario","type":"text"},domProps:{"value":_vm.value.horaTarefa},on:{"change":function($event){return _vm.updateHour()}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe9c6e7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lead/form/InputHora.vue
// module id = null
// module chunks = 